module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"delivered":"Wareneingang","ordered":"Bestellung Industrie","orderPlaced":"Bestellungsaufgabe"},"en":{"delivered":"Delivered","ordered":"Ordered","orderPlaced":"orderPlaced"}}')
  delete Component.options._Ctor
}
